import React from "react";
import { Modal, Form, Checkbox } from "antd";
import { observer } from "mobx-react";
import { volunteersStore } from "../../../store/volunteer/VolunteersStore";

export const VolunteerCancelDlg = observer(() => {
  const [form] = Form.useForm();

  const store = volunteersStore;

  const ok = () => {
    return form.validateFields().then((values) => {
      console.log("values", values);

      return store.cancelStore.save(values.date);
    });
  };

  return (
    <Modal
      title="Cancel Volunteer"
      visible={true}
      confirmLoading={store.cancelStore.saving}
      maskClosable={false}
      onOk={ok}
      onCancel={() => store.cancelStore.close()}
    >
      <Form
        layout="vertical"
        form={form}
        initialValues={{
          date: [],
        }}
      >
        <Form.Item
          label="Select date to cancel"
          name="date"
          rules={[
            {
              required: true,
              type: "array",
              message: "Please select at least one date to cancel",
            },
          ]}
        >
          <Checkbox.Group options={store.cancelStore.schedule.map((x) => ({ label: x, value: x }))}></Checkbox.Group>
        </Form.Item>
      </Form>
    </Modal>
  );
});
